import React, { useState, useEffect } from 'react';
import Header from './Header';

function SuperAdminDashboard() {
  const [activeTab, setActiveTab] = useState('overview');
  const [allForms, setAllForms] = useState([]);
  const [allSubmissions, setAllSubmissions] = useState([]);

  useEffect(() => {
    loadData();
  }, []);

  const loadData = () => {
    const forms = JSON.parse(localStorage.getItem('forms') || '[]');
    const submissions = JSON.parse(localStorage.getItem('submissions') || '[]');
    setAllForms(forms);
    setAllSubmissions(submissions);
  };

  const departments = [
    { name: 'Department A', admin: 'Admin A', users: 2 },
    { name: 'Department B', admin: 'Admin B', users: 2 },
    { name: 'Department C', admin: 'Admin C', users: 1 }
  ];

  return (
    <div className="min-h-screen bg-gray-50">
      
      <Header />

      <div className="p-6">
        
        {/* Tabs */}
        <div className="bg-white rounded-lg shadow-sm mb-6">
          <div className="flex gap-1 p-2 border-b">
            <button
              onClick={() => setActiveTab('overview')}
              className={`px-4 py-2 rounded-md font-medium transition ${
                activeTab === 'overview' 
                  ? 'bg-blue-600 text-white' 
                  : 'text-gray-600 hover:bg-gray-100'
              }`}
            >
              Overview
            </button>
            <button
              onClick={() => setActiveTab('departments')}
              className={`px-4 py-2 rounded-md font-medium transition ${
                activeTab === 'departments' 
                  ? 'bg-blue-600 text-white' 
                  : 'text-gray-600 hover:bg-gray-100'
              }`}
            >
              Departments
            </button>
            <button
              onClick={() => setActiveTab('forms')}
              className={`px-4 py-2 rounded-md font-medium transition ${
                activeTab === 'forms' 
                  ? 'bg-blue-600 text-white' 
                  : 'text-gray-600 hover:bg-gray-100'
              }`}
            >
              All Forms
            </button>
            <button
              onClick={() => setActiveTab('submissions')}
              className={`px-4 py-2 rounded-md font-medium transition ${
                activeTab === 'submissions' 
                  ? 'bg-blue-600 text-white' 
                  : 'text-gray-600 hover:bg-gray-100'
              }`}
            >
              All Submissions
            </button>
          </div>
        </div>

        {/* Overview Tab */}
        {activeTab === 'overview' && (
          <div className="grid grid-cols-3 gap-6">
            
            <div className="bg-white rounded-lg shadow-sm p-6">
              <h3 className="text-sm font-medium text-gray-600 mb-2">Total Departments</h3>
              <p className="text-3xl font-bold text-blue-600">3</p>
            </div>

            <div className="bg-white rounded-lg shadow-sm p-6">
              <h3 className="text-sm font-medium text-gray-600 mb-2">Total Forms</h3>
              <p className="text-3xl font-bold text-green-600">{allForms.length}</p>
            </div>

            <div className="bg-white rounded-lg shadow-sm p-6">
              <h3 className="text-sm font-medium text-gray-600 mb-2">Total Submissions</h3>
              <p className="text-3xl font-bold text-purple-600">{allSubmissions.length}</p>
            </div>

          </div>
        )}

        {/* Departments Tab */}
        {activeTab === 'departments' && (
          <div className="bg-white rounded-lg shadow-sm p-6">
            <h2 className="text-lg font-semibold text-gray-800 mb-4">Department Management</h2>
            
            <div className="space-y-3">
              {departments.map((dept, index) => (
                <div 
                  key={index}
                  className="flex items-center justify-between p-4 border border-gray-200 rounded-md"
                >
                  <div>
                    <p className="font-medium text-gray-800">{dept.name}</p>
                    <p className="text-sm text-gray-600">Admin: {dept.admin}</p>
                    <p className="text-sm text-gray-600">Users: {dept.users}</p>
                  </div>
                  <button className="px-4 py-2 text-blue-600 hover:bg-blue-50 rounded transition">
                    View Details
                  </button>
                </div>
              ))}
            </div>
          </div>
        )}

        {/* All Forms Tab */}
        {activeTab === 'forms' && (
          <div className="bg-white rounded-lg shadow-sm p-6">
            <h2 className="text-lg font-semibold text-gray-800 mb-4">All Forms</h2>
            
            {allForms.length === 0 ? (
              <div className="text-center py-12 text-gray-500">
                No forms created yet
              </div>
            ) : (
              <div className="space-y-3">
                {allForms.map((form) => (
                  <div 
                    key={form.id}
                    className="flex items-center justify-between p-4 border border-gray-200 rounded-md"
                  >
                    <div>
                      <p className="font-medium text-gray-800">{form.name}</p>
                      <p className="text-sm text-gray-600">Department: {form.department}</p>
                      <p className="text-sm text-gray-600">Created by: {form.createdBy}</p>
                      <p className="text-sm text-gray-600">Fields: {form.fields.length}</p>
                    </div>
                    <button className="px-4 py-2 text-blue-600 hover:bg-blue-50 rounded transition">
                      View Form
                    </button>
                  </div>
                ))}
              </div>
            )}
          </div>
        )}

        {/* All Submissions Tab */}
        {activeTab === 'submissions' && (
          <div className="bg-white rounded-lg shadow-sm p-6">
            <h2 className="text-lg font-semibold text-gray-800 mb-4">All Submissions</h2>
            
            {allSubmissions.length === 0 ? (
              <div className="text-center py-12 text-gray-500">
                No submissions yet
              </div>
            ) : (
              <div className="space-y-3">
                {allSubmissions.map((submission) => (
                  <div 
                    key={submission.id}
                    className="p-4 border border-gray-200 rounded-md"
                  >
                    <div className="flex items-center justify-between mb-2">
                      <p className="font-medium text-gray-800">{submission.formName}</p>
                      <span className="text-xs text-gray-500">
                        {new Date(submission.submittedAt).toLocaleDateString()}
                      </span>
                    </div>
                    <p className="text-sm text-gray-600">Department: {submission.department}</p>
                    <p className="text-sm text-gray-600">Submitted by: {submission.submittedBy}</p>
                  </div>
                ))}
              </div>
            )}
          </div>
        )}

      </div>

    </div>
  );
}

export default SuperAdminDashboard;